// src/utils/standardOrder.js — put a page's topics in standard-number order.
//
// A layout's `topicOrder` says how kids see its topics:
//   "standard" (the default)  by Standard Number — K.1, K.2 … K.10 (numbers
//                             compare as numbers, so K.10 comes after K.9)
//   "manual"                  exactly as arranged with the arrows in the
//                             Layout Builder
// Topics with no standard number keep their arranged order, after the rest.

const chunks = (s) => String(s || "").toLowerCase().match(/\d+|[a-z]+/g) || [];

export function compareStandards(a, b) {
  const x = chunks(a);
  const y = chunks(b);
  for (let i = 0; i < Math.max(x.length, y.length); i += 1) {
    if (x[i] === undefined) return -1;
    if (y[i] === undefined) return 1;
    const nx = /^\d+$/.test(x[i]);
    const ny = /^\d+$/.test(y[i]);
    if (nx && ny) {
      const d = Number(x[i]) - Number(y[i]);
      if (d) return d;
    } else if (nx !== ny) {
      return nx ? -1 : 1; // "K.1" before "K.a"
    } else if (x[i] !== y[i]) {
      return x[i] < y[i] ? -1 : 1;
    }
  }
  return 0;
}

const byArranged = (a, b) => (a.order || 0) - (b.order || 0);

/** a sorted copy; `mode` is the layout's topicOrder */
export function orderTopics(topics = [], mode = "standard") {
  const list = [...(topics || [])].sort(byArranged);
  if (mode === "manual") return list;
  return list
    .map((t, i) => ({ t, i }))
    .sort((a, b) => {
      const sa = String(a.t?.standardNumber || "").trim();
      const sb = String(b.t?.standardNumber || "").trim();
      if (sa && sb) return compareStandards(sa, sb) || a.i - b.i;
      if (sa) return -1;
      if (sb) return 1;
      return a.i - b.i;
    })
    .map((x) => x.t);
}
